var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:({ width: _vm.width + 'rem', height: _vm.height + 'rem' }),attrs:{"src":_vm.newSrc,"fit":_vm.fit}})
}
var staticRenderFns = []

export { render, staticRenderFns }